/* bsb-confetti.js — window.bsbConfetti(count, originX, originY).
   Canvas is created lazily; loop stops when particles clear.
   Respects prefers-reduced-motion (no-op). */

(function () {
  'use strict';

  if (window.bsbConfetti) return; // already loaded

  const COLORS = [
    '#FFD700', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4',
    '#FFEAA7', '#DDA0DD', '#98FB98', '#F0E68C', '#FF69B4',
  ];

  const reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let canvas, ctx, pieces = [], running = false, raf;

  function init() {
    if (canvas) return;
    canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText =
      'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:99999';
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    resize();
    window.addEventListener('resize', resize);
  }

  function resize() {
    if (!canvas) return;
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
  }

  function rand(min, max) {
    return Math.random() * (max - min) + min;
  }

  function burst(count, originX, originY) {
    if (reduceMotion) return;
    init();

    const n  = count || 80;
    const cx = originX != null ? originX : window.innerWidth / 2;
    const cy = originY != null ? originY : window.innerHeight * 0.45;

    for (let i = 0; i < n; i++) {
      pieces.push({
        x: cx + rand(-60, 60),
        y: cy + rand(-20, 20),
        vx: rand(-6, 6),
        vy: rand(-12, -4),
        size: rand(6, 12),
        color: COLORS[Math.floor(rand(0, COLORS.length))],
        rot: rand(0, 360),
        rotV: rand(-4, 4),
        life: 1,
        decay: rand(0.012, 0.022),
        shape: Math.random() > 0.5 ? 'rect' : 'circle',
      });
    }

    if (!running) {
      running = true;
      raf = requestAnimationFrame(loop);
    }
  }

  function loop() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    pieces = pieces.filter((p) => p.life > 0);

    pieces.forEach((p) => {
      p.x   += p.vx;
      p.y   += p.vy;
      p.vy  += 0.25;     // gravity
      p.rot += p.rotV;
      p.life -= p.decay;

      ctx.save();
      ctx.globalAlpha = Math.max(0, p.life);
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot * Math.PI / 180);
      ctx.fillStyle = p.color;

      if (p.shape === 'circle') {
        ctx.beginPath();
        ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
        ctx.fill();
      } else {
        ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
      }
      ctx.restore();
    });

    if (pieces.length > 0) {
      raf = requestAnimationFrame(loop);
    } else {
      running = false;
      cancelAnimationFrame(raf);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  }

  window.bsbConfetti = burst;
})();
